import React from 'react';
import { string, bool, node } from 'prop-types';
import cx from 'classnames';
import twoNumbers from 'propTypes/twoNumbers';
import styles from './tooltip.scss';

export default function Tooltip({ className, children, offset, sticky }) {
  // eslint-disable-next-line global-require
  const { Tooltip: LeafletTooltip } = require('react-leaflet');
  // eslint-disable-next-line global-require
  const { Point } = require('leaflet');

  return (
    <LeafletTooltip opacity={1} offset={new Point(...offset)} direction="top" sticky={sticky}>
      <div className={cx(styles.main, className)}>
        <ul className={styles.list}>
          {children}
        </ul>
      </div>
    </LeafletTooltip>
  );
}

Tooltip.propTypes = {
  className: string,
  offset: twoNumbers,
  sticky: bool,
  children: node.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/Tooltip/index.js